import { render, staticRenderFns } from "./RegistroEmpresas.vue?vue&type=template&id=e2fc4f18&"
import script from "./RegistroEmpresas.vue?vue&type=script&lang=js&"
export * from "./RegistroEmpresas.vue?vue&type=script&lang=js&"
import style0 from "./RegistroEmpresas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports